import { ArrowLeft, Download, Fullscreen, List, Settings } from 'lucide-react'

import { Button } from '@/components/ui/button'

import { usePdfViewerContext } from './pdf-viewer-provider'

interface PdfViewerHeaderProps {
  title?: string
  sourceUrl: string
  isDownloadable?: boolean
}

export function PdfViewerHeader({ title, sourceUrl, isDownloadable = false }: PdfViewerHeaderProps) {
  const { setSettingsOpen, setTocOpen, settingsOpen, tocOpen, toggleFullscreen } = usePdfViewerContext()

  const handleBack = () => {
    if (window.parent !== window) {
      window.parent.postMessage({ type: 'CLOSE_RESOURCE_MODAL' }, '*')
      return
    }
    window.history.back()
  }

  return (
    <header className="flex h-14 items-center justify-between border-b border-white/10 bg-black/85 px-3 text-white backdrop-blur md:px-5">
      <div className="flex min-w-0 items-center gap-3">
        <Button
          onClick={handleBack}
          size="icon"
          variant="ghost"
          className="h-9 w-9 border border-white/15 bg-white/5 hover:text-white text-white hover:bg-white/20 "
          aria-label="Back"
        >
          <ArrowLeft className="size-4" />
        </Button>
        <p className="truncate text-sm font-semibold md:text-base">{title || 'PDF Reader'}</p>
      </div>

      <div className="flex items-center gap-1">
        <Button
          size="icon"
          variant="ghost"
          className={`h-8 w-8 hover:bg-white/15 hover:text-white ${settingsOpen ? 'bg-white/15 text-white' : 'text-white/80'}`}
          onClick={() => setSettingsOpen(!settingsOpen)}
        >
          <Settings className="size-4" />
        </Button>
        <Button
          size="icon"
          variant="ghost"
          className={`h-8 w-8 hover:bg-white/15 hover:text-white ${tocOpen ? 'bg-white/15 text-white' : 'text-white/80'}`}
          aria-label="Toggle table of contents"
          onClick={() => setTocOpen(!tocOpen)}
        >
          <List className="size-4" />
        </Button>
        {isDownloadable && (
          <Button
            asChild
            size="icon"
            variant="ghost"
            className="h-8 w-8 text-white/80 hover:bg-white/15 hover:text-white"
          >
            <a href={sourceUrl} download={title || 'resource.pdf'} aria-label="Download PDF">
              <Download className="size-4" />
            </a>
          </Button>
        )}
        <Button
          size="icon"
          variant="ghost"
          className="h-8 w-8 text-white/80 hover:bg-white/15 hover:text-white"
          aria-label="Fullscreen"
          onClick={toggleFullscreen}
        >
          <Fullscreen className="size-4" />
        </Button>
      </div>
    </header>
  )
}
